import script from "./ResultTypeSettingsDefaultRightSide.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultTypeSettingsDefaultRightSide.vue?vue&type=script&setup=true&lang=js"

import "./ResultTypeSettingsDefaultRightSide.vue?vue&type=style&index=0&id=28138e42&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28138e42"]])

export default __exports__